import { Fragment } from 'react';

import AthleteUserContactsLargeGrid from './AthleteUserContactsLargeGrid';
import AthleteUserContactsSmallGrid from './AthleteUserContactsSmallGrid';

const AthleteUserContactsGrid = ({ gridData, isLoading, onEditContact, onDeleteContactClicked }) => {
  return (
    <Fragment>
      {isLoading === false ?
        <div className="row">
          <div className="col-xs-12">
            <p>{gridData.length === 1 ? `${gridData.length} Entry Contact` : `${gridData.length} Entry Contacts`}</p>
          </div>
        </div>
        : <Fragment><div className="row usas-extra-top-margin usas-extra-bottom-margin"></div></Fragment>}
      <AthleteUserContactsLargeGrid
        gridData={gridData}
        isLoading={isLoading}
        onEditContact={onEditContact}
        onDeleteContactClicked={gridData.length > 1 ? onDeleteContactClicked : undefined}
      />
      <AthleteUserContactsSmallGrid
        gridData={gridData}
        isLoading={isLoading}
        onEditContact={onEditContact}
        onDeleteContactClicked={gridData.length > 1 ? onDeleteContactClicked : undefined}
      />
    </Fragment>
  )
};

export default AthleteUserContactsGrid;